import { ScreenReaderOnly } from '@mnd-frontend/ui';
import React from 'react';
import styled, { css } from 'styled-components';

type ImgType = 'div' | 'img';
type ImgProps = {
  as?: ImgType;
  id?: string | null;
  alt: string;
  width?: string;
  height?: string;
  cropping?: {
    width: number;
    height: number;
    x: number;
    y: number;
  };
  imageUrl?: string | null;
};

const isImgTag = (type: ImgType | undefined) => !type || type === 'img';

const Img = styled(
  ({
    src,
    as,
    alt,
    ...rest
  }: {
    src?: string | null;
    as?: ImgType;
    alt: string;
    width?: string;
    height?: string;
    forwardedAs?: ImgType;
  }) =>
    !as || isImgTag(as)
      ? React.createElement('img', { src, alt, ...rest })
      : React.createElement(as, rest, <ScreenReaderOnly>{alt}</ScreenReaderOnly>),
)`
  ${({ width }) => width && `width: ${width}; `}
  ${({ height }) => height && `height: ${height}; `}
  ${({ forwardedAs, src }) =>
    isImgTag(forwardedAs)
      ? css``
      : css`
          background-color: #ccc;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: 50% 50%;
          background-image: url(${src});
        `}
`;

const CloudinaryImage: React.FC<ImgProps> = ({ id, cropping, as, imageUrl, ...props }) => {
  if (!imageUrl) return null;

  return <Img src={imageUrl} forwardedAs={as} {...props} />;
};

export default CloudinaryImage;
